import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';

import { SedsModalComponent } from './seds-modal.component';
import { SedsModalService } from './service/seds-modal-service';

@NgModule({
  declarations: [SedsModalComponent],
  imports: [CommonModule, MatDialogModule, MatIconModule],
  providers: [
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true, autoFocus: 'first-tabbable' } },
    SedsModalService,
  ],
  exports: [SedsModalComponent, MatDialogModule],
})
export class SedsModalModule {}
